import { render } from "./confirm-cancel-vip.vue?vue&type=template&id=797ba540&scoped=true&ts=true"
import script from "./confirm-cancel-vip.vue?vue&type=script&lang=ts"
export * from "./confirm-cancel-vip.vue?vue&type=script&lang=ts"

import "./confirm-cancel-vip.vue?vue&type=style&index=0&id=797ba540&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797ba540"]])

export default __exports__